import { Button } from "antd";
import styled from "styled-components";

import { SecondaryText } from "@/components/Typography/Styled";

export const StyledCHCopyButton = styled(Button)`
    border: none;
    box-shadow: none;
    color: ${(props) => props.theme.primaryTypographyColor};
    background-color: transparent !important;
    span {
        font-size: 20px !important;
    }
`;

export const StyledCHTypography = styled(SecondaryText)<{
    isAmount?: boolean;
}>`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    && {
        color: ${(props) =>
            props?.isAmount ? "#1677FF" : props.theme.secondaryTypographyColor};
        text-decoration: ${(props) => (props?.isAmount ? "underline" : "none")};
    }
`;
